export interface IMicrositeImage {
    caption: string;
    fileName: string;
    thumbnail: string;
    displayOrder: number;
}